/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetPaymentMethods } from 'services/api/paymentsApi';
import { TPaymentMethodsList, TPaymentMethodsState } from 'typings';

export const fetchPaymentMethods = createAsyncThunk(
  'user/paymentMethods',
  async (_payload, thunkAPI) => {
    try {
      const response = await GetPaymentMethods();
      return response.data as TPaymentMethodsList;
    } catch {
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialCardState: TPaymentMethodsState = {
  allPaymentMethods: [],
  isLoading: false
};

export const paymentMethodsSlice = createSlice({
  name: 'paymentMethods',
  initialState: initialCardState,
  reducers: {
    clearPaymentMethods: (state) => {
      state.allPaymentMethods = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allPaymentMethods = action.payload.payment_method;
      })
      .addCase(fetchPaymentMethods.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPaymentMethods.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export const { clearPaymentMethods } = paymentMethodsSlice.actions;

export default paymentMethodsSlice.reducer;
